// extracted by mini-css-extract-plugin
export default {"expiredLongTermMedication":"PatientMedicationGrid_expiredLongTermMedication__e3tKy","spanSlashSpacing":"PatientMedicationGrid_spanSlashSpacing__IdU3B"};